module.exports = __webpack_public_path__ + "media/images/cart_white-8f0de32a2ba912135676b5c22c65b3cf.svg";